import { getMempoolApiUrl } from '../getMempoolApiUrl';
import { satoshisToBtc } from '../satoshisToBtc';

export const fetchBtcBalance = async ({
  address,
}: {
  address: string;
}): Promise<string | null> => {
  const API_URL = getMempoolApiUrl(address);

  const response = await fetch(`${API_URL}/address/${address}`);

  if (!response.ok) {
    return null;
  }

  const addressInfo = await response.json();

  if (!addressInfo?.chain_stats || !addressInfo?.mempool_stats) {
    return null;
  }

  const confirmedBalanceInSats =
    Number(addressInfo.chain_stats.funded_txo_sum) -
    Number(addressInfo.chain_stats.spent_txo_sum);

  const unconfirmedBalanceInSats =
    Number(addressInfo.mempool_stats.funded_txo_sum) -
    Number(addressInfo.mempool_stats.spent_txo_sum);

  const balance = satoshisToBtc(
    confirmedBalanceInSats + unconfirmedBalanceInSats
  );

  return balance.toString();
};
